// extracted by mini-css-extract-plugin
export default {"content":"FormContent_content__6wDt0","button_submit":"FormContent_button_submit__AoRW+"};